export default class ClientModule {
    static clientName(info) {
        return info.surname && info.name
            ? `${info.surname} ${info.name} ${info.patronymic || ''}`
            : info.name;
    }
    static searchValues(step) {
        const steps = {
            0: {iin: '', phone: '7'},
            1: {document: '', surname: '', name: ''},
            2: {iin: ''},
            3: {name: ''}
        };

        return steps[step] || {};
    }
    static filterStep(filter) {
        const resident = filter.resident
        const person   = filter.person
        switch (true) {
            case (resident && person)  :return 0;
            case (!resident && person) :return 1;
            case (resident && !person) :return 2;
            case (!resident && !person):return 3;
        }
    }
    static documentType(step) {
        const documentTypes = {
            0: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
            1: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
            default: {7: 'Свидетельство о государственной регистрации (перерегистрации) юридического лица'}
        };

        return documentTypes[step] || documentTypes.default;
    }
    static isFilled(value) {
        return value !== null && value !== undefined && value !== ''
    }
    static flattenToValues(obj) {
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {}
        const result = {}
        const take = (source) => {
            if (!source || typeof source !== 'object' || Array.isArray(source)) return
            Object.keys(source).forEach(key => {
                const value = source[key]
                if (value !== null && typeof value === 'object') return
                if (this.isFilled(value) || !this.isFilled(result[key])) {
                    result[key] = value
                }
            })
        }

        take(obj.client)
        take(obj.filter)
        take(obj.location)
        take(obj.document)
        take(obj)

        if (obj.client) {
            if (!this.isFilled(result.name)) result.name = obj.client.name || obj.client.title || result.name
            if (!this.isFilled(result.iin)) result.iin = obj.client.iin ?? result.iin
        } else if (!this.isFilled(result.name) && obj.title) {
            result.name = obj.title
        }

        return result
    }
}
